import { Component, OnInit, ViewChild } from "@angular/core";
import {  UntypedFormGroup,  UntypedFormControl,  UntypedFormBuilder,  Validators,} from "@angular/forms";
import { DateValidation } from "../../validators/dateValidation";
import { ToastrService } from "ngx-toastr";
import {  SPINNER_ANIMATIONS,  SPINNER_PLACEMENT,  ISpinnerConfig,  NgxSpinner,} from "@hardpool/ngx-spinner";
import { DriverReport } from "../../model/report/driverReport";
import { ExcelReportWriterHelper } from "../../helpers/excelReportWriterHelper";
import { LoggerService } from "../../services/logger.service";
import { ReportService } from "../../services/report.service";
import { WorkShiftService } from "../../services/workShift.service";

@Component({
  selector: "driver",
  templateUrl: "driver.component.html",
  styleUrls: ["driver.component.css"],
})
export class DriverComponent implements OnInit {
  @ViewChild("spinner", { static: true }) spinner: NgxSpinner;

  searchForm: UntypedFormGroup;
  busy: boolean = false;
  spinnerConfig: ISpinnerConfig;
  maxDate: Date = new Date();

  dateControl: UntypedFormControl = new UntypedFormControl([
    Validators.required,
    DateValidation(),
  ]);

  driverControl: UntypedFormControl = new UntypedFormControl("", Validators.required);
  driverNames: string[] = [];
  driverReports: DriverReport[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private logger: LoggerService,
    private readonly toaster: ToastrService,
    private readonly workShiftService: WorkShiftService,
    private readonly reportService: ReportService
  ) {
    this.searchForm = this.fb.group({
      date: this.dateControl,
      driver: this.driverControl,
    });
  }

  ngOnInit() {
    this.spinnerConfig = {
      placement: SPINNER_PLACEMENT.block_ui,
      animation: SPINNER_ANIMATIONS.horizontal_bounce,
      size: "2rem",
      color: "#7AB800",
      bgColor: "rgba(255,255,255,1)",
    };

    this.dateControl.valueChanges.subscribe((value) => {
      this.driverReports = [];
      this.driverNames = [];
      this.driverControl.setValue("");
      try {
        this.workShiftService
          .getAvailabilityForReports("ARN", new Date(value))
          .then((result) => {
            if (result.length > 0) {
              this.driverControl.setValue("Alla");
              this.driverNames = [
                "Alla",
                ...result.sort((s1: string, s2: string) =>
                  this.sortNames(s1, s2)
                ),
              ];
            }
          });
      } catch (error) {
        this.logger.logError(error);
      }
    });
  }

  canSearch() {
    return this.searchForm.valid && !this.busy;
  }

  async search() {
    if (this.searchForm.valid) {
      this.spinner.show();
      let date = new Date(this.dateControl.value);
      let driver = this.driverControl.value;
      this.busy = true;

      try {
        let result: any = await this.reportService.getDriverReports(
          date.toDateString(),
          driver
        );
        this.spinner.hide();
        if (result) {
          this.driverReports = result.sort(
            (r1: DriverReport, r2: DriverReport) =>
              this.sortNames(r1.driverName, r2.driverName)
          );
        }
        this.busy = false;
      } catch (error) {
        this.spinner.hide();
        this.driverReports = null;
        this.busy = false;
        console.log(error);
        this.showError("Ett fel uppstod vid inläsning av data.");
      }
    }
  }

  showError(message: string) {
    this.toaster.error(message);
  }

  public exportSummary() {
    ExcelReportWriterHelper.exportDriverReport(
      this.driverReports,
      this.dateControl.value
    );
  }

  private sortNames(s1: string, s2: string): number {
    return s1 > s2 ? 1 : -1;
  }
}
